const MetaTrader5ContentTwo = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Multi-Asset Trading Environment </h4>
              </div>
              <p>
                Trade across Forex, Stocks, Indices, Commodities, and
                Cryptocurrencies, all from one platform. MT5 offers an expanded
                market range, letting you diversify your portfolio seamlessly.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Superior Charting & Analytical Tools</h4>
              </div>
              <p>
                Access 21 timeframes, 80+ technical indicators, and an unlimited
                number of charts to refine your trading strategies. The Pips MT5
                gives you deeper market insight and sharper analysis to make
                confident decisions.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Enhanced Order Management System</h4>
              </div>
              <p>
                Execute complex order types with precision. MT5 supports
                advanced pending orders and depth of market (DOM) functionality,
                providing greater flexibility for high-level trading strategies.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Integrated Economic Calendar & Market Depth</h4>
              </div>
              <p>
                Stay informed with real-time macroeconomic updates, event
                forecasts, and in-platform analysis. MT5’s market depth and
                economic calendar allow traders to anticipate volatility and act
                proactively.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTrader5ContentTwo;
